import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BrainCircuit, ClipboardCheck } from 'lucide-react';

interface GeneratingFeedbackModalProps {
  visible: boolean;
  isImplementorInterview?: boolean;
}

const GeneratingFeedbackModal: React.FC<GeneratingFeedbackModalProps> = ({ visible, isImplementorInterview = false }) => {
  if (!visible) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
        >
          <motion.div
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.3, delay: 0.1 }}
            className="bg-background-light dark:bg-background-dark rounded-xl border border-border-light dark:border-border-dark shadow-lg max-w-md w-full mx-4 p-6"
          >
            <div className="flex flex-col items-center">
              <div className="bg-primary-light/10 dark:bg-primary-dark/10 rounded-full p-4 mb-4">
                {isImplementorInterview ? (
                  <ClipboardCheck size={32} className="text-primary-light dark:text-primary-dark animate-pulse" />
                ) : (
                  <BrainCircuit size={32} className="text-primary-light dark:text-primary-dark animate-pulse" />
                )}
              </div>
              
              <h3 className="text-xl font-semibold text-text-primary-light dark:text-text-primary-dark mb-2">
                {isImplementorInterview ? 'Generating Report' : 'Generating Feedback'}
              </h3>
              
              <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark text-center mb-4">
                {isImplementorInterview 
                  ? 'The AI Interviewer is analyzing your screening interview and preparing a comprehensive report. Hang tight! 📋'
                  : 'The AI Interviewer is analyzing your interview and generating comprehensive feedback. Get a cup of tea and relax ☕️...'
                }
              </p>
              <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark text-center mb-4">
                This may take <span className="text-text-primary-light dark:text-text-primary-dark font-medium">
                  {isImplementorInterview ? '30-45 seconds' : '45-60 seconds'}
                </span> or less. {isImplementorInterview ? 'Your report will be ready shortly!' : 'The wait is worth it!'}
              </p>
              <div className="flex justify-center items-center space-x-2 my-2">
                <span className="w-3 h-3 rounded-full bg-primary-light dark:bg-primary-dark animate-pulse" style={{ animationDelay: "0s" }}></span>
                <span className="w-3 h-3 rounded-full bg-primary-light dark:bg-primary-dark animate-pulse" style={{ animationDelay: "0.2s" }}></span>
                <span className="w-3 h-3 rounded-full bg-primary-light dark:bg-primary-dark animate-pulse" style={{ animationDelay: "0.4s" }}></span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default GeneratingFeedbackModal; 